import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useCheckAlwaysAllowLocationSettingIsEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.CHECK_ALWAYS_ALLOW_LOCATION_SETTING, {
    defaultValue: false,
  });
}
